import React from 'react';
import { useSelector } from 'react-redux';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { getOwner } from 'reactApp/modules/folderAccessControlList/folderAccessControlList.selectors';
import { getPublicOwner } from 'reactApp/modules/public/public.selectors';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { isFileCancel } from 'reactApp/modules/uploadList/uploadList.getters';
import { EFileError } from 'reactApp/modules/uploadList/uploadList.model';
import { getWarningFile } from 'reactApp/modules/uploadList/uploadList.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { OverQuotaComponent } from 'reactApp/ui/UploadList/PopupWarnings/OverQuota';
import { OverWriteComponent } from 'reactApp/ui/UploadList/PopupWarnings/OverWrite';

export const PopupWarningsContainer = () => {
    const warningFile = useSelector(getWarningFile);
    const isPhone = useSelector(EnvironmentSelectors.isPhone);
    let problem;

    const currentStorage = useSelector(getCurrentStorage);
    const { isPublic } = getStorage(currentStorage);

    const publicOwner = useSelector(getPublicOwner);
    const acOwner = useSelector(getOwner);
    const owner = isPublic ? publicOwner : acOwner;

    const currentUserEmail = useSelector(UserSelectors.getEmail);

    const isStrangerOwner = !!currentUserEmail && !!owner?.email && currentUserEmail !== owner?.email;

    if (!warningFile || isFileCancel(warningFile)) {
        return null;
    }

    switch (warningFile.error) {
        case EFileError.OVER_QUOTA_CLOUD: {
            problem = <OverQuotaComponent file={warningFile} isStrangerOwner={isStrangerOwner} />;
            break;
        }
        case EFileError.FILE_EXIST: {
            problem = <OverWriteComponent file={warningFile} isPhone={isPhone} />;
            break;
        }
    }

    if (!problem) {
        return null;
    }

    return <>{problem}</>;
};
